import { createEvent } from 'effector'

const updateSteamId = createEvent<string>()
const updateUserLanguage = createEvent<string>()
const updatePremiumStatus = createEvent<boolean>()
const setIsFirstLogin = createEvent<boolean>()
export const deleteExternalProfile = createEvent()
export const clearUsersByGamedId = createEvent()
export const changeLocalPrivacy = createEvent<boolean>()

export { updateSteamId, updateUserLanguage, updatePremiumStatus, setIsFirstLogin }
